"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedTeamBudget = void 0;
const AggregatedBudget_1 = require("./AggregatedBudget");
class AggregatedTeamBudget extends AggregatedBudget_1.AggregatedBudget {
    constructor(teamId) {
        super();
        this.teamId = teamId;
    }
}
exports.AggregatedTeamBudget = AggregatedTeamBudget;
//# sourceMappingURL=AggregatedTeamBudget.js.map